import SimpleTable from "@/components/SimpleTable";
import { RegularAssessment } from "@/schema/console/regular-assessments/RegularAssessment";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface ActiveAssesmentTableProps {
  isLoading: boolean;
  activeTests: RegularAssessment[];
}

function ActiveAssesmentTable({
  isLoading,
  activeTests,
}: ActiveAssesmentTableProps) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="mb-5 text-lg font-bold">{t("current-active-test")}</div>
      <SimpleTable
        isLoading={isLoading}
        data={activeTests}
        columns={[
          {
            label: t("version"),
            key: "version",
            render: ({ id }) => `${t("version")} ${id}`,
          },
          {
            label: t("published-date"),
            key: "publishedDate",
            render: ({ created_at }) =>
              format(new Date(created_at), t("date-time-format")),
          },
          {
            label: t("test-takers"),
            key: "testTakers",
            render: ({ test_takers }) => `${test_takers} ${t("completed")}`,
          },
          {
            label: t("published-by"),
            key: "publishedBy",
            render: ({ created_by }) => (
              <div className="flex flex-col">
                <span>{created_by.name}</span>
                <span className="text-cool-gray-600">{created_by.email}</span>
              </div>
            ),
          },
        ]}
      />
    </div>
  );
}

export default ActiveAssesmentTable;
